import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.0895 4.09377L13.9187 6.54954C14.8458 7.49654 15.3498 8.56778 15.5453 9.71293C16.2136 9.25045 16.9804 8.90181 17.7613 8.71021C17.7879 8.7037 17.8148 8.69738 17.8421 8.69125L16.6292 6.6516L18.3482 5.62937L20.1357 8.63536C20.9311 8.74885 21.7584 9.00045 22.4934 9.43493C22.5476 9.46698 22.6015 9.50011 22.6549 9.53432C22.312 8.22324 21.7292 6.87987 20.9769 5.71586C20.0975 4.35536 18.8775 3.08145 17.3916 2.48472C15.7974 1.84446 14.2023 2.44446 14.0938 4.04297C14.0926 4.06011 14.0912 4.07704 14.0895 4.09377Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0828 4.12142L11.8567 7.37184L12.226 7.69846C13.3908 8.72867 13.7816 9.99212 13.6032 11.6109C13.2756 11.6193 12.9378 11.6567 12.6083 11.728C12.5979 11.7104 12.5874 11.6929 12.5768 11.6757C12.3329 11.2798 11.984 10.8898 11.5463 10.5827C10.7562 10.0283 9.6745 9.75252 8.50491 10.1899C7.89886 9.84157 7.3278 9.57095 6.79019 9.3726C6.71087 9.34333 6.63141 9.31551 6.55186 9.28911L9.40605 5.75618L7.85031 4.49933L4.2882 8.90852C3.33658 8.89926 2.4296 9.08004 1.6426 9.41917C1.50962 9.47647 1.37879 9.53907 1.25084 9.60684C1.91299 6.51974 3.84217 3.97327 6.50926 2.47939C7.55491 1.8937 8.65203 1.59787 9.68412 1.62473C11.4345 1.67028 12.1822 2.53539 12.086 4C12.0833 4.04151 12.0822 4.08199 12.0828 4.12142Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.02417 12.7407C1.34205 17.6054 4.76961 21.5252 9.31327 22.6665C9.04876 21.6545 8.82129 20.465 8.72426 19.2518L3.58556 14.0575L5.00737 12.6509L8.79177 16.4763C9.03455 15.0038 9.67209 13.5583 10.8 12.6152C10.695 12.4723 10.5577 12.3322 10.3974 12.2198C10.0324 11.9636 9.55665 11.8409 8.93371 12.1908L8.41805 12.4803L7.91587 12.168C7.22494 11.7382 6.62057 11.4418 6.0979 11.249C4.7492 10.7513 3.40425 10.8378 2.43406 11.2559C1.58123 11.6234 1.12933 12.1779 1.02417 12.7407Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.4274 19.054L11.1122 21.6055C10.8297 20.3724 10.6341 18.9528 10.6811 17.6442C10.7442 15.8896 11.4455 14.4469 12.4822 13.8757C12.9126 13.6386 13.6715 13.5466 14.2717 13.6516L15.1608 13.8072L15.4064 12.9386C15.5344 12.4856 15.8736 11.9997 16.4035 11.5677C16.9282 11.14 17.5832 10.8132 18.2379 10.6526C19.0033 10.4648 20.4267 10.5365 21.4757 11.1566C21.9741 11.4513 22.3601 11.8521 22.5794 12.3879C22.7995 12.9257 22.8899 13.6934 22.6305 14.786L22.6483 14.7903C21.4649 19.3738 17.4276 22.7439 12.5607 22.9855L19.8559 14.9456L18.3747 13.6016L15.4432 16.8324L15.4504 15.8183L13.4505 15.8041L13.4274 19.054Z"}}]};

const CabbageFilled = Vue.extend<IconProps>({
  name: 'CabbageFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cabbage-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CabbageFilled;
